import { Location, User } from '../models/user.model';
import { TreeTable } from 'primeng/primeng';

export class ReportMetadata {
  id: string;
  reportNumber: string;
  category: string;
  reportName: string;
  fasPost: string;
  country: string;
  programArea: string;
  division: string;
  dueDate: Date;
  proposedDueDate:Date;
  dueDateInNextYear: Date;
  region: string;
  reportType: string;
  fasPostId: number;
  approverId: number;
  highlights: string;
  preparedBy: string;
  selected?: boolean = false;
  countries?: Location[];
  posts?: Location[];
  regionId?: number;
  countryId?: number;
  isRequired: boolean;
  isPublic?: boolean;
  //Commented by SC added isPublic instead of distribution
  //distribution:boolean;
  distribution: string;
  categoryName: string;
  isReleased: boolean;
  categoryId: number;
  reportState: string;
  reportStateId: number;
  isReportLocked:boolean;
  categoryParentId?: number;
  categoryParent?: string;
  categoryTreeTable?: TreeTable;
  requiredCount?: number;
  voluntaryCount?: number;
  lastUpdatedDatetime:Date;
  postLocation?: string;
  parentPostLocation?: string;
  reportDueDate?: Date;
  postLocationId?: number;
  parentPostLocationId?: number;
  ProgramAreaName?: string;
  ProgramAreaId?: number;
  reportStatusId?:number;
  frequencyTypeId?:number;
  frequencyTypeName?:string;
  FrequencyType?:FrequencyType;
  isReportPublished?:boolean;
}

export class Approver {
  id: number;
  name: string;
} 

export class ReportCategory {
  id: number;
  categoryName: string;
  parentCategoryId: number;
  programAreaId?: number;
  isActive:boolean;
  lastUpdatedDatetime:Date;
  autoPublishPolicyId:number;
}

export class ReportYear {
  id: number;
  year: number;
}


export class UserReportCategory {
  userReportCategoryId: number;
  categoryId: number;
  categoryName: string;
}

export class ReportSchedule {
  Id: string;
  ProgramAreaId: number;
  ReportYear: number;
  ReportYearId: number;
  CategoryId: number;
  ReportName: string;
  IsRequired: boolean;
  IsPublic: boolean;
  PostLocationId: number;
  ParentLocationId: number;
  ReportDueDate: Date;
  ProposedDueDate?:Date;
  IsReleased: boolean;
  reportState?: string;
  reportStateId?: number;
  reportNumber?: string;
  FrequencyTypeId?:number;
  isReportPublished?:string;
}

export class VoluntaryReportMetadata {
  id: any;
  reportNumber: string;
  reportName: string;
  distributionType: string;
  reportCategory: ReportCategory[];
  reportDate: Date;
  post: Location;
  country: Location;
  region: string;
  preparedBy: string;
  disclaimer: string;
  reportHighlights: string;
  //approvedBy:Approver;
  approvedBy: User;
  reportState: string;
  reportStateId: number;
  isReportLocked:boolean;
}

export class ReportAuditRecord {
  reportActionName: string;
  processedBy: string;
  processedDateTime: Date;
  userComments: string;
}

export class ReportingInstructions {
  id: string;
  parentId: string;
  type: number;
  name: string;
  contentType: string;
  content: any[];
  contentLength: number;
}

export class ReportState{
  id: number;
  stateName: string;
}
export class FrequencyType
{
  id:number;
  frequencyTypeName:string;
}

export class ReportAttachment
{
  id:number;
  reportMetadataId:string;
  attachmentName:string;
  //attachmentContent:any[];
}
export class Report{
  id:any;
  reportName:string;
  reportNumber:string;
  country:string;
  fasPost:string;
  reportType:string;
  distribution:string;
  reportState:string;
  reportStateId:number;
  isReportPublished:boolean;
}

export class  ReportScheduleResults
{
Id: string;
ReportName: string;
ReportYearId: number;
IsRequired: boolean;
IsPublic: boolean;
AutoPublishPolicyId: number;
PostLocationId: number;
ParentPostLocationId: number;
ReportDueDate: Date;
IsReleased: boolean;
PostLocation: string;
ParentPostLocation: string;
ReportYear: number;
CategoryId: number;
CategoryName: string;
ProgramAreaName: string;
ProgramAreaId: number;
}

export class PublishedReport
{
Id: string;
PostLocationId: number;
CountryId: number;
RegionId: number;
ReportYearId: number;
PublishedOn: number;
ReportContent: any[];
TrackingId: string;
FileName: string;
FileExtension: string;
ReportSchedule: ReportSchedule[];
}
//This enum needs to match the reportStates enum in the domain layer
export enum ReportStates
{
  NotStarted=1,
  Draft=2,
  SubmittedToPostApprover= 3,
  ApproveAndSendToWashingtion=4,
  ReturnFromPostApprover=5,
  ReturnFromWashington=6,
  Validated =7, 
  Published=8,
  Hold =9
}

export class ReportAutoPublishPolicy{
  id:number;
  policyName:string;
}

export class ReportType{
  id: number;
  description: string;
  isRequired: boolean;
}

export class ReportDistributionType{
  id: number;
  description: string;
  isPublic: boolean;
}




// WEBPACK FOOTER //
// ./src/app/models/report.model.ts